import { getLogsRequest } from '../../api/LogRequest';
import { LOAD_REQUEST, GET_LOGS, LOAD_DONE } from '../types';
import { checkIfResponseOk } from './AuthActions';

export const getLogsAction = (values) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_REQUEST });

    const { data } = await getLogsRequest(values);
    if (data?.error?.code === '1') {
      dispatch({ type: LOAD_DONE });
      return { error: 1, message: data?.error?.message };
    }
    checkIfResponseOk(data, dispatch);

    dispatch({ type: GET_LOGS, payload: data.content.data.all });
    return 0;
  } catch (err) {
    dispatch({ type: LOAD_DONE });
    return { error: 1, message: err.message };
  }
};
